/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Swimming_CoachingInputs */

const en_service_type_swimming_coaching = /** @type {(inputs: Service_Type_Swimming_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swimming coaching`)
};

const pl_service_type_swimming_coaching = /** @type {(inputs: Service_Type_Swimming_CoachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauka i trening pływania`)
};

/**
* | output |
* | --- |
* | "Swimming coaching" |
*
* @param {Service_Type_Swimming_CoachingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_swimming_coaching = /** @type {((inputs?: Service_Type_Swimming_CoachingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Swimming_CoachingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_swimming_coaching(inputs)
	return en_service_type_swimming_coaching(inputs)
});